import { action, API, controller } from "api";
import { useAppContext } from "context";
import { InputAuto } from "controls";
import { lsGet, lsSave, Model, UseForm } from "hooks";
import { Form } from "layout";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Header from "./Header";
import { useTranslation } from "react-i18next";

const Body = ({ setShowForm }) => {
  const { t } = useTranslation(['common', 'forms', 'alerts']);
  const { setBizContext, setSelCompany } = useAppContext();
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [outlets, setOutlets] = useState([]);
  const { BizContextMdl } = Model();
  const { values, setValues, errors, setErrors, handleInpChg } = UseForm(BizContextMdl);

  const autoSelect = (bizValues) => {
    setBizContext({ ...bizValues });
    lsSave("bizContext", bizValues);
    setSelCompany(bizValues?.companyId);
    setShowForm(false);
  };

  useEffect(() => {
    var _bizContext = lsGet("bizContext");

    if (_bizContext === null || !_bizContext?.outletId) {
      setLoading(true);
      setShowForm(true);
      API(controller.Company + action.GetLabels).get((res) => {
        if (res?.status === 200) {
          var result = res?.result;
          setCompanies([...result]);
          // Auto-select if only one company
          if (result.length === 1) {
            setValues((j) => ({ ...j, companyId: result[0].id }));
          }
        } else toast.error(res?.msg);
        setLoading(false);
      });
    } else {
      setShowForm(false);
      setBizContext({ ..._bizContext });
      setSelCompany(_bizContext?.companyId);
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!values?.companyId) return;
    API(controller.Outlet + action.GetLabelsByCo).getById(
      values.companyId,
      (res) => {
        if (res?.status === 200) {
          var result = res?.result;
          setOutlets([...result]);
          // Auto-select if only one outlet
          if (result.length === 1) {
            const bizValues = { ...values, outletId: result[0].id };
            autoSelect(bizValues);
          }
        } else toast.error(res?.msg);
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.companyId]);

  const validateForm = () => {
    let temp = {};
    temp.companyId = values.companyId !== "" ? "" : t('alerts:companyRequired');
    temp.outletId = values.outletId !== "" ? "" : t('alerts:outletRequired');

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setBizContext({ ...values });
      lsSave("bizContext", values);
      setSelCompany(values?.companyId);
      setShowForm((prev) => !prev);
    }
  };

  return !loading ? (
    <Form onSubmit={handleSubmit} noValidate>
      {/* -------- Header -------- */}
      <Header />
      {/* -------- Body -------- */}

      <div className="flex flex-col gap-5 p-[12px] mt-[12px]">
        <InputAuto
          fullWidth
          label={t('forms:company')}
          name="companyId"
          value={values.companyId}
          error={errors.companyId}
          required={true}
          onChange={handleInpChg}
          options={companies}
        />

        <InputAuto
          disabled={!values?.companyId}
          fullWidth
          label={t('outlet')}
          name="outletId"
          value={values.outletId}
          error={errors.outletId}
          required={true}
          onChange={handleInpChg}
          options={outlets}
        />
      </div>
    </Form>
  ) : (
    <Loading />
  );
};

export default Body;

const Loading = () => {
  const { t } = useTranslation(['common']);
  return (
    <span className="font-medium text-[18px] text-gray-500 p-[30px]">
      {t('loadingDots')}
    </span>
  );
};
